import Vue from "vue";
import axios, { AxiosInstance } from "axios";

// @NOTICE Authorization header will be set in @core/auth/jwt/jwtService via @/auth/jwt/useJwt. Should not be in @core...
const axiosInstance: AxiosInstance = axios.create({
    baseURL: `https://${process.env.VUE_APP_INSIGHTS_URL}/`,
});

Vue.prototype.$http = axiosInstance;

export default axiosInstance;
